import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import Environment from './utils/Environement';
import { connectDatabaseEmulator, getDatabase } from 'firebase/database';
import { connectStorageEmulator, getStorage } from 'firebase/storage';

const firCredentialsDev = {
  apiKey: "AIzaSyDgFZ-0X4wmGnDVmB6tUXtTarp5r3k77n0",
  authDomain: "popina-dev.firebaseapp.com",
  databaseURL: "https://popina-dev.firebaseio.com",
  projectId: "popina-dev",
  storageBucket: "popina-dev.appspot.com",
  messagingSenderId: "615353036864",
  appId: "1:615353036864:web:5a24b44caaacef3de42fa5"
};

const firCredentialsProd = {
  apiKey: "AIzaSyCGWgQOslwuwH34jTzPKrMkCtVoncAFHRM",
  authDomain: "popina-prod.firebaseapp.com",
  databaseURL: "https://popina-prod.firebaseio.com",
  projectId: "popina-prod",
  storageBucket: "popina-prod.appspot.com",
  messagingSenderId: "1070476676107",
  appId: "1:1070476676107:web:1cb2ace9bcc578fa030b0e"
};

const firCredentialsDevJalia = {
  apiKey: "AIzaSyBnuuf9OfkajiIkbnyNoTHYKA0B21m17hQ",
  authDomain: "jalia-dev.firebaseapp.com",
  databaseURL: "https://jalia-dev-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "jalia-dev",
  storageBucket: "jalia-dev.appspot.com",
  messagingSenderId: "798468508376",
  appId: "1:798468508376:web:c730962bd52b02097ee5ad",
  measurementId: "G-6DWCG4SLEJ"
};

const firCredentialsProdJalia = {
  apiKey: "AIzaSyBuWfJV6yIpBKzlvbT60zP7LNTRdkTqMSs",
  authDomain: "jalia-prod.firebaseapp.com",
  databaseURL: "https://jalia-prod-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "jalia-prod",
  storageBucket: "jalia-prod.appspot.com",
  messagingSenderId: "790693845339",
  appId: "1:790693845339:web:d4930c5225632f2613e27e",
  measurementId: "G-42FJ7JS711"
};

const app = initializeApp(
  (Environment.isDev === true)
  ? (Environment.isPopina)
    ? firCredentialsDev
    : firCredentialsDevJalia
  : (Environment.isPopina)
    ? firCredentialsProd
    : firCredentialsProdJalia
);

const useFirebaseEmulator = process.env.REACT_APP_USE_FIREBASE_EMULATOR === "true";

if (useFirebaseEmulator) {
  console.log('here we use the emulators')
  const storage = getStorage()
  connectStorageEmulator(storage, "localhost", 9199)
  const db = getDatabase()
  connectDatabaseEmulator(db, "localhost", 9000)
  const auth = getAuth()
  connectAuthEmulator(auth, "http://localhost:9099");
}

console.log("Environment: ", (Environment.isDev) ? "Dev" : "Prod");
console.log("Application: ", (Environment.isPopina) ? "Popina" : "Jalia");

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

export default app;
